
import SelectNumberButton from '@/components/common/input/SelectNumberButton.vue'
import RadioGroup from '@/components/common/input/RadioGroup.vue'
import SwiperWrap from '@/components/pd/common/SwiperCmp.vue'
import BoxPdFlag from '~/components/common/product/BoxPdFlag.vue'

import '@/assets/scss/2_component/_prodtool.scss'

import { pdMixin } from '@/mixin/pd/pdMixin'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  components: {
    CommonImage,
    SelectNumberButton,
    RadioGroup,
    SwiperWrap,
    BoxPdFlag
  },
  mixins: [pdMixin],
  props: {
    item: { // 상품정보
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    viewType: { // 화면 구성 타입 (gnr: 일반, bun: 세트상품, gf: 상품권)
      type: String,
      default: ''
    },
    sideBar: { // 사이드바 여부(true: 사이드바, false: 상단 기본정보)
      type: Boolean,
      default: false
    },
    selPdList: { // 선택한 옵션 리스트
      type: [Object, Array],
      default: () => {
        return {}
      }
    },
    dlvcPlcy: { // 배송정책
      type: Object,
      default: () => {
        return {}
      }
    },
    syncOptBox: { // 옵션 선택 select box
      type: String,
      default: ''
    },
    pkgList: {
      type: [Array],
      default: () => []
    },
    purchaseValue: { // 01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량배송
      type: String,
      default: '01'
    },
    massDlvUnable: { // 대량배송 불가 여부
      type: Boolean,
      default: false
    },
    pkupDlvUnable: { // 매장픽업 불가 여부
      type: Boolean,
      default: false
    },
    quickDlvUnable: { // 오늘배송 불가 여부
      type: Boolean,
      default: false
    },
    dlvDt: { // 택배배송 도착예정 날짜
      type: String,
      default: ''
    },
    massDlvDt: { // 대량주문 도착예정 날짜
      type: String,
      default: ''
    },
    regDlvDt: { // 정기배송 도착예정 날짜
      type: String,
      default: ''
    },
    massOfflCntrStck: { // 대량주문 재고 수량
      type: Number,
      default: 0
    },
    pkupOfflStrStck: { // 픽업매장 재고 수량
      type: Number,
      default: 0
    },
    newPkupOfflStrStck: { // 매장픽업 재고조회
      type: Object,
      default: () => {
        return {}
      }
    },
    quickOfflStrStck: { // 오늘배송 재고 수량
      type: Number,
      default: 0
    },
    sideBarPkgYn: { // 덕용 상품일 때 사이드바 총량 및 총액 계산을 위한 파라미터
      type: Boolean,
      default: false
    },
    isOpenRun: { // 오픈런상품유무
      type: Boolean,
      default: false
    },
    opRunAncYn: { // 판매시작알림신청여부
      type: String,
      default: 'N'
    },
    opRunDt: { // 판매시작일시 포맷
      type: String,
      default: ''
    },
  },
  data () {
    return {
      cnt: 1,
      sleParamNtcnYn: 'N', // 판매알림신청여부
      selOpt: '', // 선택 옵션
      cartType: '', // 장바구니 타입
      // 덕용상품 옵션선택 임의 데이터
      activeOption: 0,
      pkgOld: 0,
      optSwiper: {
        auto: false,
        loop: false,
        lazy: true,
        navigation: true,
        pagination: false,
        freeMode: true,
        slidesPerView: 'auto'
      },
      visibleTool: false, // 덕용 타이틀 tooltip
      pkgValue: 0,
      optPkgValue: '', // 덕용상품 옵션 있는 상품은 초기 라디오 값 선택 없음
      // optPkgSetYn: true, // 덕용상품 옵션 첫 선택 구분자 (처음일 경우 옵션박스 세팅, 아닐 경우 수량 변경)
      optPkgSetList: [], // 덕용상품 이미 선택한 옵션 구분자
      gfMin: 1,
      isOldChange: {
        val: 0,
        pdNo: ''
      },
      isAlert: false,
      dlvParmDay: '', // 배송예정일
      spbkSeCd: '', // 장바구니구분코드
      selectNumberItem: {}, // 상품수량 선택을 위한 파라미터
      isChkPkg: false, // 덕용 체크 여부
      pkupStore: {}, // 선택한 픽업매장
      firstTime: true
    }
  },
  computed: {
    // 옵션여부
    isOpt () {
      console.log(this.item.pdOpt)
      if (this.isNotEmpty(this.item.pdOpt)) {
        return this.item.pdOpt.length > 0
      }
      return false
    },
    // 덕용여부
    isPkg () {
      return this.item.pkgYn === 'Y'
    },
    soldout () {
      // 품절여부 : 택배상품이고, 상품권 아니고, 재고수량 0 이하
      console.log('soldout', this.item.stckQy <= 0, this.item.pdsOrPsblYn === 'Y', this.viewType)

      if (this.isOpenRun) {
        return true
      }

      if (this.viewType === 'bun') {
        return this.item.bunMaxOrQy <= 0
      } else if (this.purchaseValue === '02') { // 매장픽업일 경우 매장 조회 결과 수량으로 체크, 옵션의 경우 옵션 전체 재고 조회 후 품절처리
        console.log(this.newPkupOfflStrStck)
        return this.pkupOfflStrStck <= 0
      } else if (this.purchaseValue === '04') { // 대량주문일 경우 오프라인 센터 재고 조회 결과 수량으로 체크, 옵션의 경우 옵션 전체 재고 조회 후 품절처리
        return this.massOfflCntrStck <= 0
      } else if (this.purchaseValue === '05') {
        return (this.quickOfflStrStck <= 0 || this.quickMaxOrPsblQy <= 0)
      } else if (this.isNotEmpty(this.item.stckQy)) {
        if (this.item.pdTy === '06') { // 전용상품
          // 품박스이면 현재 재고가 1중포보다 작을 경우 soldout
          return this.item.stckQy < this.item.jpQy
          // return false
        }
        return this.item.stckQy <= 0 && this.item.sleStsCd === '03' && this.item.pdsOrPsblYn === 'Y' && this.viewType !== 'gf'
      }
      return false
    },
    tbSle () {
      // 판매예정 : 판매상태가 (02)판매 예정
      console.log('tbSle', this.item.sleStsCd)
      return this.item.sleStsCd === '02'
    },
    stopSale () {
      // 판매 중지(픽업불가, 택배불가 상품)
      console.log('stopSale', this.item.sleStsCd, this.item.pdsOrPsblYn, this.item.pkupOrPsblYn)
      return this.item.sleStsCd === '04' || (this.item.pdsOrPsblYn === 'N' && this.item.pkupOrPsblYn === 'N' && this.item.pdTy !== '03')
    },
    massOr () {
      // 대량주문 가능상품(택배배송이면서 대량주문 수량있고 대량주문 가능 상품)
      // 24.01.18 대량주문 가능상품(픽업 주문도 가능)
      console.log('massOr', this.item.pdsOrPsblYn, this.item.massOrPsblYn, this.item.htrkCnvMummQy)
      // return this.item.pdsOrPsblYn === 'Y' && this.item.massOrPsblYn === 'Y' && this.item.htrkCnvMummQy > 0
      return this.item.massOrPsblYn === 'Y' && this.item.htrkCnvMummQy > 0
    },

    onlyPkup () {
      // 픽업전용 상품
      return this.item.onlyPkup
    },
    buy () {
      // 구매하기 버튼 : 판매상태 판매중이고, 굿즈 아니고, 세트상품 아니고 택배상품
      // DEV-3179 세트 상품도 구매하기 노출되도록 처리
      console.log('buy', this.item.sleStsCd === '03', this.item.pdTy, this.item.pdsOrPsblYn)
      return (this.item.sleStsCd === '03' && this.item.pdTy !== '04' && this.item.pdsOrPsblYn === 'Y') || this.viewType === 'bun'
    },
    cart () {
      // 장바구니 버튼 : 판매상태 판매중
      return this.item.sleStsCd === '03'
    },
    totalCnt () {
      // 최종 구매수량
      if (this.viewType === 'bun') {
        return this.selPdList[0].bunCnt
      } else {
        let cnt = 0
        if (this.isOpt) {
          if (this.purchaseValue !== '04') {
            this.selPdList.forEach((opt) => {
              cnt += parseInt(opt.cnt)
            })
          } else if (this.purchaseValue === '04' && this.item.pdTy === '05') {
            this.selPdList.forEach((item) => {
              cnt += Math.floor(item.cnt / this.item.jpQy)
            })
          } else {
            cnt += Math.floor(this.selPdList[0]?.cnt / this.item.jpQy)
          }

          return cnt
        } else if (this.isPkg && this.purchaseValue === '01' && this.pkgList[0].boxQy > 0 && this.pkgValue === 0) {
          cnt = this.pkgList[0].boxQy * this.item.jpQy
        } else {
          cnt += parseInt(this.selPdList[0]?.cnt)
        }

        if (this.sideBarPkgYn) {
          return Math.floor(cnt / this.item.jpQy)
        }

        if (this.isChkPkg || this.purchaseValue === '04') {
          return Math.floor(cnt / this.item.jpQy)
        } else {
          return cnt
        }
      }
    },
    totalPrice () {
      // 최종 구매금액
      if (this.viewType === 'bun') {
        return this.totalCnt * this.item.pdPrc
      } else if (this.isPkg && this.purchaseValue === '01' && this.pkgList[0].boxQy > 0 && this.pkgValue === 0) {
        const price = this.pkgList[0].boxQy * this.item.jpQy * this.item.pdPrc

        return price
      } else {
        let price = 0
        this.selPdList.forEach((opt) => {
          price += opt.cnt * opt.pdPrc
        })

        return price
      }
    },
    pdCnt: {
      get (item) {
        if (this.viewType === 'bun') {
          return this.selPdList[0].bunCnt
        } else if (this.viewType !== 'bun' && (this.purchaseValue === '04' || this.isChkPkg || this.sideBarPkgYn)) {
          if (this.item.pdTy === '05') {
            const selectedOpt = this.selPdList[this.selPdList.findIndex(e => parseInt(e.onldPdNo) === parseInt(item.selOpt))]
            return this.selPdList.length === 0 ? 0 : Math.floor(selectedOpt?.cnt / this.item.jpQy)
          } else {
            return this.selPdList.length === 0 ? 0 : Math.floor(this.selPdList[0].cnt / this.item.jpQy)
          }
          // return this.selPdList.length === 0 ? 0 : Math.floor(this.selPdList[0].cnt / this.item.jpQy)
        } else if (this.purchaseValue === '01' && this.item.pkgYn === 'Y' && this.pkgValue === 0 && this.pkgList[0].boxQy > 0) {
          this.chkPkg()

          return this.pkgList.length === 0 ? this.selPdList[0].cnt : this.pkgList[0].boxQy
        } else {
          return this.selPdList.length === 0 ? 0 : this.selPdList[0].cnt
        }
      },
      set (cnt) {
        // 덕용상품일 경우 radio data 셋팅
        console.log('pdCnt set')
        this.setOldValRd(cnt)
      }
    },
    isDlvUnable () { // 배송가능 여부
      if (this.soldout) {
        return true
      } else if (this.purchaseValue === '02' && this.pkupDlvUnable && this.optQyChk) { // 매장픽업
        return true
      } else if (this.purchaseValue === '04' && this.massDlvUnable && this.optQyChk) { // 대량주문
        return true
      } else if (this.purchaseValue === '05' && this.quickDlvUnable && this.optQyChk) { // 오늘배송
        return true
      } else {
        return false
      }
    },
    setDlvParmDay () {
      switch (this.purchaseValue) {
        case '01' : // 택배
          return this.dlvParmDay
        case '03' : // 정기
          return this.regDlvDt
        case '04' : // 대량
          return this.massDlvDt
        default :
          return ''
      }
    },
    btnCase () {
      switch (this.purchaseValue) {
        case '01' : // 택배
          return '장바구니 담기'
        case '02' : // 픽업
          return '매장픽업 장바구니 담기'
        case '03' : // 정기
          return '정기배송 장바구니 담기'
        case '04' : // 대량
          return '대량주문 장바구니 담기'
        case '05' : // 대량
          return '오늘배송 장바구니 담기'
        default :
          return ''
      }
    },
    btnActiveYn () { // 버튼 활성화 여부
      if (this.purchaseValue !== '01' && this.purchaseValue !== '05') { // 택배 배송이 아닌 경우
        if (this.isDlvUnable && this.isLogin) { // 배송 불가하고 로그인 하였을 때
          return true // 버튼 미노출
        } else {
          return false // 배송 불가하나 로그인 하지 않았을 때 버튼 노출
        }
      } else if (this.isDlvUnable) { // 택배 배송 외 배송 불가한 경우
        return true // 버튼 미노출
      } else {
        return false
      }
    },
    // 옵션 상품에 대하여 수량 체크
    optQyChk () {
      if (this.isOpt) {
        if (this.purchaseValue === '02') {
          if (this.item.pdTy === '05' && this.isLogin) {
            let optStck = 0
            this.item.onldOpt.forEach((item) => {
              if (item.pkupStck) {
                optStck += item.pkupStck
              }
            })
            return optStck <= 0
          } else {
            return this.pkupOfflStrStck <= 0
          }
        } else if (this.purchaseValue === '05') {
          if (this.item.pdTy === '05' && this.isLogin) {
            let optQuickStck = 0
            this.item.onldOpt.forEach((item) => {
              if (item.quickStck) {
                optQuickStck += item.quickStck
              }
            })
            return optQuickStck <= 0
          } else {
            return this.pkupOfflStrStck <= 0
          }
          // if (this.quickOfflStrStck > 0) {
          //   return false
          // } else {
          //   return true
          // }
        } else if (this.purchaseValue === '04') {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    },
    gfcardYn () {
      // 상품권 여부
      return this.item.pdTy === '03'
    }
  },
  watch: {
    syncOptBox (opt) {
      this.selOpt = opt
    },
    // 덕용상품 스와이퍼 옵션 변경
    activeOption (data) {
      // 옵션값 변경되었을 때 selPdList에서 해당 cnt와 radio 값 같은 것 있으면 연동
      const idx = this.selPdList.findIndex(e => e.onldPdNo === this.item.pdOpt[data].onldPdNo)
      console.log(idx, this.item.pdOpt[data].onldPdNo)
      if (idx > -1) {
        const pkgIdx = this.pkgList.findIndex(e => parseInt(e.optQy) === parseInt(this.selPdList[idx].cnt))
        this.onPkgRdSet(pkgIdx)
      } else {
        this.onPkgRdSet('')
      }
      // 스와이퍼 옵션 변경시 재고 체크 후 재고 이상인 라디오버튼 disabled 처리
      this.setPkgDisabled(data)
    },
    purchaseValue (item) {
      this.selOpt = '' // 상품 상세에서 칩 변경 시 selOpt 초기화
      this.isChkPkg = false // 덕용 체크 여부 초기화
      this.pkgValue = 0 // 수량 옵션 값 초기화

      if (item === '04') {
        this.$emit('syncOptData', { type: 'cnt', pdNo: this.item.onldPdNo, cnt: this.item.htrkCnvMummQyNum })
      } else {
        this.$emit('syncOptData', { type: 'cnt', pdNo: this.item.onldPdNo, cnt: 1 })
      }
    }
  },
  // OR-528 컴포넌트 value 변경 시 동기화
  beforeMount () {
    this.$EventBus.$on('changeNumber', (pdNo, curr, old, pkgYn) => {
      // 덕용상품일 경우 라디오 맞추기
      if (this.isPkg) {
        // 이미 선택 옵션이 있는지
        if (this.$refs.inputNum !== undefined) {
          const selIdx = this.selPdList.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))

          // 선택 옵션이 있다면 해당 값과 라디오 일치 필요
          if (selIdx > -1) {
            // 스와이퍼 변경시 해당 옵션의 선택값 가져오기
            if (this.isOpt) {
              const optIdx = this.$refs.inputNum.findIndex(e => parseInt(e.itemInfo.pdNo) === parseInt(pdNo))
              if (optIdx !== -1) {
                const pkgIdx = this.pkgList.findIndex(e => parseInt(e.optQy) === parseInt(this.$refs.inputNum[optIdx].inputValue))
                this.onPkgRdSet(pkgIdx === -1 ? '' : pkgIdx)
              }
            } else if (this.isChkPkg) {
              if (parseInt(this.$refs.inputNum.inputValue) !== 0) {
                const pkgIdx = this.pkgList.findIndex(e => parseInt(e.optQy) === (parseInt(this.$refs.inputNum.inputValue) * parseInt(this.item.jpQy)))
                this.onPkgRdSet(pkgIdx === -1 ? '' : pkgIdx)
              }
            } else if (!this.isChkPkg && this.pkgList[0].optQy === parseInt(this.$refs.inputNum.inputValue)) {
              this.onPkgRdSet(0)
            }
          }
        }
      }
      this.setData('cnt', pdNo, { curr, old }, pkgYn)
    })

    this.$EventBus.$on('chg-pkup-str', (pkupStr) => { // 선택한 픽업 매장
      this.pkupStore = pkupStr
      console.log('pkupStore', this.pkupStore)
    })
  },
  beforeDestroy () {
    this.$EventBus.$off('changeNumber')
    this.$EventBus.$off('sel-offl-str-stck')
    this.$EventBus.$off('chg-pkup-str')
  },
  mounted () {
    // input box 숫자만 입력 가능하게 변경
    if (this.$refs.inputNum) {
      if (this.$refs.inputNum.constructor === Array) {
        this.$refs.inputNum.forEach((item) => {
          item.$el.querySelectorAll('.el-input input')[0].attributes.type.value = 'number'
        })
      } else {
        this.$refs.inputNum.$el.querySelectorAll('.el-input input')[0].attributes.type.value = 'number'
      }
    }

    // 덕용상품인 경우 재고 체크
    if (this.isPkg) {
      if (this.isOpt) {
        // 덕용상품 옵션 중 품절인 옵션 있을 경우 다음 활성화
        for (let i = 0; i < this.item.pdOpt.length; i++) {
          if (this.item.pdOpt[i].soldout && (this.activeOption === i)) {
            this.activeOption++
          }
        }
      }
      // for문 종료 (activeOption 판단 후) 후 disabled 실행
      this.setPkgDisabled(this.activeOption)
    }
  },
  methods: {
    // 옵션, 카운트 셋팅
    setData (type, pdNo, cnt, pkgYn) {
      console.log('pjm', this.viewType === 'gnr', this.totalCnt < 1, !(this.isChkPkg || this.purchaseValue === '04'))
      if ((this.purchaseValue === '02' || this.purchaseValue === '05') &&
        (this.isDlvUnable ||
          (this.purchaseValue === '02'
            ? (this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))].pkupStck)
            : (this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))].quickStck)) <= 0)) {
        if (cnt.curr === 0) {
          const errMsg = (this.purchaseValue === '01' || this.purchaseValue === '02' || this.purchaseValue === '03' || this.purchaseValue === '05') ? '1개부터 구매 가능한 상품입니다.' : ''
          this.$notify.closeAll()
          this.openToast(errMsg)
          this.$nextTick(() => {
            this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
          })
        }
        return false
      }

      console.log(this.item, this.purchaseValue === '04', cnt.curr)
      // if (this.item.pdTy === '05' && this.purchaseValue === '04' && (type === 'cnt' && (parseInt(cnt.curr) < this.item.htrkCnvMummQy))) {
      //   // const minCnt = pkgYn === 'Y' || this.item.pdTy === '06' ? `1박스(${this.item.jpQy}개)` : '1개'
      //   const errMsg = `${this.item.htrkCnvMummQy}박스 (${this.item.htrkCnvMummQyNum}개)부터 구매 가능한 상품입니다.`
      //   this.$notify.closeAll()
      //   this.openToast(errMsg)
      //
      //   console.log(type, cnt.old * this.item.jpQy)
      //   console.log(type, this.item.jpQy, cnt.old)
      //   this.$nextTick(() => {
      //     this.$emit('syncOptData', { type, pdNo, cnt: this.item.jpQy * cnt.old })
      //   })
      //   return
      // }

      let param = { type, pdNo, cnt: typeof cnt === 'object' ? cnt.curr : cnt, pkgYn }
      if (this.purchaseValue === '04' && this.item.pdTy === '05') {
        if (type === 'cnt' && (parseInt(param.cnt) < this.item.htrkCnvMummQy)) {
          const errMsg = `${this.item.htrkCnvMummQy}박스 (${this.item.htrkCnvMummQyNum}개)부터 구매 가능한 상품입니다.`
          this.$notify.closeAll()
          this.openToast(errMsg)
          this.$nextTick(() => {
            this.$emit('syncOptData', { type, pdNo, cnt: this.item.jpQy * cnt.old })
          })
        }
        param.cnt = this.isEmpty(param.cnt) || param.cnt < Math.floor(this.item.htrkCnvMummQyNum / this.item.jpQy) ? this.item.htrkCnvMummQyNum : param.cnt * this.item.jpQy
      } else {
        param.cnt = this.isEmpty(param.cnt) ? 1 : param.cnt
      }

      this.$emit('syncOptData', param) // 금액 셋팅

      // 판매중지 상태거나, 품절일 때 선택수량 0으로 셋팅하고 return
      // 옵션 상품일 경우에는 옵션 수량 체크 로직 추가
      if ((this.stopSale || (this.soldout && this.purchaseValue !== '05')) && this.optQyChk) {
        param = { type: 'cnt', pdNo, cnt: 0 }
        this.$emit('syncOptData', param)
        return
      }
      // 옵션 있는 덕용상품 삭제할 경우, 선택된 옵션 목록에서도 지워야 함
      if (this.isOpt && this.isPkg && type === 'del') {
        this.optPkgSetList = this.optPkgSetList.filter(e => e !== pdNo)
        // 삭제시 라디오버튼도 초기화
        this.onPkgRdSet('')
      }

      let avlbCnt = 0

      if (this.purchaseValue === '02') { // 픽업매장인 경우
        if (this.item.pdTy === '05') {
          const selectedOpt = this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))]
          avlbCnt = selectedOpt.pkupStck <= selectedOpt.maxOrPsblQy ? selectedOpt.pkupStck : selectedOpt.maxOrPsblQy
        } else {
          avlbCnt = !this.isOpt ? this.item.maxOrPsblQy > this.pkupOfflStrStck ? this.pkupOfflStrStck : this.item.maxOrPsblQy : this.pkupOfflStrStck
        }
      } else if (this.purchaseValue === '04') { // 대량주문일 경우
        // 대량주문 최대구매기준이 관리자설정 일 경우('02')
        if (this.item.massMaxOrPsblQyStdrCd === '02') {
          avlbCnt = this.item.massMaxOrPsblQy * this.item.jpQy
        } else {
          // 오프라인 수량기준 가장 큰 중포 수량
          avlbCnt = Math.floor(this.massOfflCntrStck / this.item.jpQy)
        }
      } else if (this.purchaseValue === '05') {
        if (this.item.pdTy === '05') {
          const quickOpt = this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))]
          if (this.quickDlvUnable) {
            console.log(this.quickOfflStrStck)
            avlbCnt = quickOpt.quickMaxOrPsblQy > this.quickOfflStrStck ? this.quickOfflStrStck : quickOpt.quickMaxOrPsblQy
          } else {
            avlbCnt = quickOpt.quickMaxOrPsblQy > quickOpt.quickStck ? quickOpt.quickStck : quickOpt.quickMaxOrPsblQy
          }
        } else {
          avlbCnt = this.item.quickMaxOrPsblQy > this.quickOfflStrStck ? this.quickOfflStrStck : this.item.quickMaxOrPsblQy
          avlbCnt = avlbCnt === 0 ? 1 : avlbCnt
        }
      } else { // 택배배송, 정기배송 일때 최대구매 수량
        // eslint-disable-next-line no-lonely-if
        if (this.isChkPkg) {
          const jpMaxQy = this.item.jpMaxOrPsblQy * this.item.jpQy
          avlbCnt = jpMaxQy > this.item.stckQy ? this.item.stckQy : jpMaxQy
        } else if (this.item.pdTy === '06') {
          avlbCnt = Math.floor(this.item.stckQy / this.item.jpQy) <= this.item.jpMaxOrPsblQy ? Math.floor(this.item.stckQy / this.item.jpQy) : this.item.jpMaxOrPsblQy
        } else if (this.item.pdTy === '05') {
          const selectedOpt = this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(pdNo))]
          avlbCnt = selectedOpt.maxOrPsblQy > selectedOpt.stckQy ? selectedOpt.stckQy : selectedOpt.maxOrPsblQy
        } else {
          avlbCnt = this.item.maxOrPsblQy > this.item.stckQy ? this.item.stckQy : this.item.maxOrPsblQy
        }
      }
      // 대량배송 이동 안내 문구
      let avlbOrMsg
      this.purchaseValue === '02'
        ? avlbOrMsg = `매장픽업 주문 가능 수량은<br>최대 ${this.numberComma(avlbCnt)}개 입니다.`
        : (this.purchaseValue === '01' && this.isChkPkg)
            ? avlbOrMsg = `택배배송 주문 가능 수량은<br>최대 ${this.numberComma(Math.floor(avlbCnt / this.item.jpQy))}박스(${this.numberComma(Math.floor(avlbCnt / this.item.jpQy) * this.item.jpQy)}개) 입니다.`
            : this.purchaseValue === '04'
              ? avlbOrMsg = `최대 주문 가능 수량은<br>${this.numberComma(Math.floor(avlbCnt))}박스(${this.numberComma(avlbCnt * this.item.jpQy)}개)입니다.`
              : this.purchaseValue === '01'
                ? avlbOrMsg = `택배배송 주문 가능 수량은 최대<br>${this.numberComma(avlbCnt)}개 입니다.`
                : this.purchaseValue === '05'
                  ? avlbOrMsg = `오늘배송 가능 수량은 최대<br>${this.numberComma(avlbCnt)}개 입니다.`
                  : avlbOrMsg = `정기배송 주문 가능 수량은 최대<br>${this.numberComma(avlbCnt)}개 입니다.`
      const massMsg = this.purchaseValue !== '04' && this.item.massOrPsblYn === 'Y' ? `<br>대량주문은 ${this.numberComma(this.item.htrkCnvMummQy)}박스(${this.numberComma(this.item.htrkCnvMummQyNum)}개)부터 주문 가능합니다.<br>[배송안내>대량주문]으로 이동하시겠습니까?` : ''

      // 세트상품
      if (this.viewType === 'bun') {
        if (this.totalCnt > this.item.bunMaxOrQy) {
          param = { type, pdNo, cnt: cnt.old }
          console.log('todo: 세트상품 구성상품 주문가능수량 초과::' + this.item.pdNo)
          this.alert(`최대 구매 가능 수량은<br>${this.item.bunMaxOrQy}세트 입니다.`, {
            okCallback: () => {
              param = { type: 'cnt', pdNo, cnt: cnt.old }
              this.$emit('syncOptData', param) // 금액 셋팅
            }
          })
        } else if (this.totalCnt <= 0) {
          console.log('todo: 세트상품 구성상품 주문가능수량 미만::' + this.item.pdNo)
          this.alert('1세트부터 구매 가능한 상품입니다.', {
            okCallback: () => {
              param = { type: 'cnt', pdNo, cnt: cnt.old }
              this.$emit('syncOptData', param) // 금액 셋팅
            }
          })
        }
        return
      }

      // 옵션상품, 상품권(매장픽업 전용은 재고체크 제외)
      if (this.isOpt && this.purchaseValue !== '04') {
        const checkOpt = this.item.pdOpt.filter(o => o.onldPdNo === param.pdNo)[0]
        // 모품번 주문가능수량과 옵션재고수량 중 작은 수량을 옵션 주문가능수량으로 셋팅(상품권은 무조건 주문 가능수량, 재고체크x)
        let optAvlbCnt = this.viewType === 'gnr' ? this.purchaseValue !== '04' ? (avlbCnt > checkOpt.stckQy ? checkOpt.stckQy : avlbCnt) : avlbCnt : this.item.maxOrPsblQy
        if (this.purchaseValue === '05') {
          optAvlbCnt = avlbCnt
        }
        const optAvlbOrMsg = `선택옵션 주문 가능 수량은 최대<br>${this.numberComma(optAvlbCnt)}개 입니다.`
        if (this.item.pdTy === '05') {
          optAvlbCnt = avlbCnt
        }
        // 선택한 옵션의 재고가 없을 때 0 셋팅
        if (type === 'ins' && checkOpt.stckQy <= 0 && this.viewType !== 'gf' && this.purchaseValue !== '02') {
          this.$emit('syncOptData', { type: 'cnt', pdNo, cnt: 0 })
        }
        if (this.viewType === 'gf') {
          if (this.totalCnt === 10) {
            this.gfMin = 0
          } else {
            this.gfMin = 1
          }
          if (this.totalCnt > 10) {
            this.alert('상품권은 한 번에 10장까지 구매 가능합니다.', {
              okCallback: () => {
                param = { type: 'cnt', pdNo, cnt: 0 }
                this.$emit('syncOptData', param) // 금액 셋팅
              }
            })
            return
          }
        }
        if (this.purchaseValue === '02' || this.purchaseValue === '05') {
          const optAvlbMsg = this.purchaseValue === '02' ? `매장픽업 주문 가능 수량은 최대<br>${avlbCnt}개 입니다.` : `오늘배송 주문 가능 수량은 최대<br>${avlbCnt}개 입니다.`
          if (avlbCnt > 0 && avlbCnt < (this.item.pdTy === '05' ? param.cnt : this.totalCnt)) {
            if (this.viewType === 'gnr' && this.massOr) {
              this.confirm(optAvlbMsg + massMsg, {
                yes: '확인',
                okCallback: () => {
                  // 대량배송은 장바구니 담고 수량 초기화
                  this.$emit('purchaseValue', '04')
                  this.$emit('isGoMass', true)
                },
                cancelCallback: () => {
                  // 이전 수량으로 변경
                  this.pkgOld = cnt.old
                  this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
                },
              })
            } else if (optAvlbCnt > 0) { // 상품권 같은 경우 주문가능수량이 0으로 들어가있을 수 있음 (maxOrPsblQy가 0일 경우 구매제한없음)
              this.$alert(optAvlbOrMsg, {
                dangerouslyUseHTMLString: true,
                callback: () => {
                  param = { type, pdNo, cnt: cnt.old }
                  this.$emit('syncOptData', param) // 금액 셋팅
                }
              })
            }
            return false
          }
        } else {
          // eslint-disable-next-line no-lonely-if
          if (optAvlbCnt > 0 && optAvlbCnt < cnt.curr) {
            if (this.viewType === 'gnr' && this.massOr) {
              this.confirm(optAvlbOrMsg + massMsg, {
                yes: '확인',
                okCallback: () => {
                  // 대량배송은 장바구니 담고 수량 초기화
                  this.$emit('purchaseValue', '04')
                  this.$emit('isGoMass', true)
                },
                cancelCallback: () => {
                  // 이전 수량으로 변경
                  this.pkgOld = cnt.old
                  this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
                },
              })
            } else if (optAvlbCnt > 0) { // 상품권 같은 경우 주문가능수량이 0으로 들어가있을 수 있음 (maxOrPsblQy가 0일 경우 구매제한없음)
              this.alert(optAvlbOrMsg, {
                okCallback: () => {
                  param = { type, pdNo, cnt: cnt.old }
                  this.$emit('syncOptData', param) // 금액 셋팅
                }
              })
            }
            this.isAlert = true
            this.isOldChange = { val: parseInt(cnt.old), pdNo }
            // 덕용상품일 경우 라디오 버튼 세팅
            if (this.isPkg) {
              this.setOldValRd(cnt.old)
            }
            return
          }
        }
        return
      }

      // 주문 가능수량 초과 시
      if (this.viewType === 'gnr' && this.totalCnt > avlbCnt && !(this.isChkPkg || this.purchaseValue === '04')) {
        if (this.massOr) {
          this.confirm(avlbOrMsg + massMsg, {
            yes: '확인',
            okCallback: () => {
              if (type === 'ins') {
                if (this.isPkg) {
                  // 덕용 상품 옵션
                  this.onPkgRdSet('')
                }
                this.$emit('syncOptData', { type: 'del', pdNo, cnt: 0 }) // 옵션박스 삭제
                this.$emit('isGoMass', true)
              } else {
                if (this.isPkg) {
                  this.setOldValRd(cnt.old)
                }
                this.$emit('purchaseValue', '04')
                this.$emit('isGoMass', true)
              }
            },
            cancelCallback: () => {
              // 이전 수량으로 변경
              if (type === 'ins') {
                // 덕용 상품 옵션의 경우 첫 진입(ins)에서 주문 가능 수량 초과할 시 라디오버튼 선택 없음으로 세팅
                if (this.isPkg) {
                  this.onPkgRdSet('')
                }
                this.$emit('syncOptData', { type: 'del', pdNo, cnt: 0 })
              } else {
                // 덕용상품 대량주문 초과시 old 값은 그 이전 값으로
                if (this.totalCnt === avlbCnt) {
                  this.setOldValRd(cnt.old)
                }
                if (this.item.pdTy === '05' && this.purchaseValue === '04') {
                  this.$emit('syncOptData', { type, pdNo, cnt: cnt.old * this.item.jpQy, pkgYn })
                } else {
                  this.$emit('syncOptData', { type, pdNo, cnt: cnt.old, pkgYn })
                }
              }
            }
          })
        } else if (this.onlyPkup) {
          // 매장픽업 주문 가능수량 안내
          if (avlbCnt > 0) {
            this.alert(avlbOrMsg, {
              okCallback: () => {
                this.$emit('syncOptData', { type, pdNo, cnt: cnt.old }) // 금액 셋팅
              }
            })
          }
        } else {
          if (this.item.pdTy === '06') {
            avlbOrMsg = `최대 주문 가능 수량은<br>${avlbCnt}박스(${Math.floor(avlbCnt * this.item.jpQy)}개)입니다.`
          }
          // 택배 주문 가능수량 안내
          this.alert(avlbOrMsg, {
            okCallback: () => {
              this.$emit('syncOptData', { type, pdNo, cnt: cnt.old }) // 금액 셋팅
            }
          })
        }
        this.isAlert = true
        this.isOldChange = { val: parseInt(cnt.old), pdNo }
        return
      } else if (this.viewType === 'gnr' && this.totalCnt < 1 && !(this.isChkPkg || this.purchaseValue === '04')) {
        const minCnt = pkgYn === 'Y' || this.item.pdTy === '06' ? `1박스(${this.item.jpQy}개)` : '1개'
        const errMsg = (this.purchaseValue === '01' || this.purchaseValue === '02' || this.purchaseValue === '03' || this.purchaseValue === '05') ? `${minCnt}부터 구매 가능한 상품입니다.` : ''

        this.$notify.closeAll()
        this.openToast(errMsg)

        this.$nextTick(() => {
          this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
        })
      }

      // 대량배송 가능 상품이고 총 수량이 용차전환수량 초과
      if ((this.purchaseValue === '04' || this.isChkPkg) && (this.totalCnt > (this.isChkPkg ? Math.floor(avlbCnt / this.item.jpQy) : avlbCnt))) {
        if (this.massOr) {
          if (this.purchaseValue !== '04') {
            this.confirm(avlbOrMsg + massMsg, {
              yes: '확인',
              okCallback: () => {
                // 대량배송 가능일 경우엔 대량주문으로 변경
                this.$emit('purchaseValue', '04')
                this.$emit('isGoMass', true)
              },
              cancelCallback: () => {
                this.setOldValRd(cnt.old)
                // 이전 수량으로 변경
                this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
              },
            })
          } else {
            this.alert(avlbOrMsg + massMsg, {
              okCallback: () => {
                // 이전 수량으로 변경
                if (type === 'ins') {
                  // 덕용 상품 옵션의 경우 첫 진입(ins)에서 주문 가능 수량 초과할 시 라디오버튼 선택 없음으로 세팅
                  if (this.isPkg) {
                    this.onPkgRdSet('')
                  }
                  this.$emit('syncOptData', { type: 'del', pdNo, cnt: 0 })
                } else {
                  // 덕용상품 대량주문 초과시 old 값은 그 이전 값으로
                  if (this.totalCnt === avlbCnt) {
                    this.setOldValRd(cnt.old)
                  }
                  if (this.item.pdTy === '05' && this.purchaseValue === '04') {
                    this.$emit('syncOptData', { type, pdNo, cnt: cnt.old * this.item.jpQy, pkgYn })
                  } else {
                    this.$emit('syncOptData', { type, pdNo, cnt: cnt.old, pkgYn })
                  }
                }
              }
            })
          }
        } else {
          this.confirm(avlbOrMsg + massMsg, {
            yes: '확인',
            okCallback: () => {
              // 대량배송 불가일 경우엔 수량 초기화
              this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
            },
            cancelCallback: () => {
              this.setOldValRd(cnt.old)
              // 이전 수량으로 변경
              this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
            },
          })
        }
        this.isAlert = true
        this.isOldChange = { val: parseInt(cnt.old), pdNo }
      } else if (this.purchaseValue === '04' && (this.totalCnt < this.item.htrkCnvMummQy)) {
        const errMsg = `${this.item.htrkCnvMummQy}박스(${this.item.htrkCnvMummQy * this.item.jpQy}개)부터 구매 가능한 상품입니다.`
        this.$notify.closeAll()
        this.openToast(errMsg)
        this.$nextTick(() => {
          this.$emit('syncOptData', { type, pdNo, cnt: cnt.old })
        })
      }
    },
    // 장바구니
    goCart (type) {
      if (!type) {
        switch (this.purchaseValue) {
          case '01' : // 택배
            this.spbkSeCd = '01'
            type = 'pds'
            break
          case '02' : // 픽업
            this.spbkSeCd = '02'
            type = 'pkup'
            break
          case '03' : // 정기
            this.spbkSeCd = '03'
            type = 'fdrm'
            break
          case '04' : // 대량
            this.spbkSeCd = '04'
            type = 'mass'
            break
          case '05' : // 대량
            this.spbkSeCd = '05'
            type = 'quick'
            break
          default :
            break
        }
      }

      this.cartType = this.onlyPkup && type !== 'mass' ? 'pkup' : type
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      // 장바구니 버튼 노출 케이스 : 픽업전용, 묶음, 대량, 정기, 옵션, 일반
      // [필수] 장바구니유형코드 spbkSeCd [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매]
      switch (type) {
        case 'bun' :
          // 세트상품 장바구니
          this.setSpbkData({
            spbkSeCd: '01',
            pdNo: '', // 상품번호
            onldPdNo: '', // 온라인전용상품번호
            bunPdNo: this.item.pdNo, // 세트상품번호
            spbkQy: this.pdCnt, // 장바구니 수량
            exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
            price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
            onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '' // GTM 작업을 위한 파라미터 추가
          })
          break
        case 'mass' :
          // 대량구매 장바구니
          if (this.item.pdTy === '05') {
            this.selPdList.forEach((pd) => {
              this.setSpbkData({
                spbkSeCd: '04',
                pdNo: pd.pdNo, // 상품번호
                onldPdNo: pd.onldPdNo, // 온라인전용상품번호(대량구매는 옵션상품이여도 모품번 기준 관리되므로 빈값 전달? 확인필요)
                bunPdNo: '',
                spbkQy: pd.cnt, // 장바구니 수량(용차전환 최소수량)
                exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
                price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
                onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
                brndNm: this.item.brndNm ? this.item.brndNm : '', // GTM 작업을 위한 파라미터 추가
                variant: undefined // GTM 작업을 위한 파라미터 추가
              })
            })
          } else {
            this.setSpbkData({
              spbkSeCd: '04',
              pdNo: this.item.pdNo, // 상품번호
              onldPdNo: '', // 온라인전용상품번호(대량구매는 옵션상품이여도 모품번 기준 관리되므로 빈값 전달? 확인필요)
              bunPdNo: '',
              spbkQy: this.pdCnt * this.item.jpQy, // 장바구니 수량(용차전환 최소수량)
              exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
              price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
              onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
              brndNm: this.item.brndNm ? this.item.brndNm : '', // GTM 작업을 위한 파라미터 추가
              variant: undefined // GTM 작업을 위한 파라미터 추가
            })
          }
          break
        default :
          if (this.isOpt) {
            // 옵션 : 픽업전용, 정기배송, 일반상품 장바구니
            const pdList = []
            this.selPdList.forEach((pd) => {
              if (pd.cnt > 0) {
                pdList.push({
                  spbkSeCd: this.purchaseValue,
                  pdNo: pd.pdNo,
                  onldPdNo: pd.onldPdNo,
                  bunPdNo: '',
                  spbkQy: pd.cnt,
                  exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
                  price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
                  onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
                  brndNm: this.item.brndNm ? this.item.brndNm : '', // GTM 작업을 위한 파라미터 추가
                  variant: pd.optCn ? this.unescape(pd.optCn) : '' // GTM 작업을 위한 파라미터 추가
                })
              }
            })
            if (!pdList.length) {
              // 옵션을 선택해주세요.
              this.alert(this.$t('PD.SELECT_OPTION'))
              return
            }
            this.setSpbkData(pdList)
          } else {
            // 옵션x : 픽업전용, 정기배송, 일반상품 장바구니
            const pd = this.selPdList[0]
            if (pd.cnt <= 0) {
              // 옵션을 선택해주세요.
              this.alert(this.$t('PD.SELECT_OPTION'))
              return
            }
            this.setSpbkData({
              spbkSeCd: this.purchaseValue,
              pdNo: this.item.pdTy === '06' ? this.item.onldOpt[0].onldPdNo : pd.pdNo,
              onldPdNo: this.item.pdTy === '06' ? this.item.onldOpt[0].onldPdNo : pd.onldPdNo,
              bunPdNo: '',
              spbkQy: this.isChkPkg || this.item.pdTy === '06' ? this.pdCnt * this.item.jpQy : this.pdCnt,
              pkgYn: this.isChkPkg || this.item.pdTy === '06' ? 'Y' : 'N',
              exhPdNm: this.item.exhPdNm ? this.item.exhPdNm : '', // GTM 작업을 위한 파라미터 추가
              price: this.item.pdPrc ? this.item.pdPrc : '', // GTM 작업을 위한 파라미터 추가
              onlSclCd: this.item.onlSclCd ? this.item.onlSclCd : '', // GTM 작업을 위한 파라미터 추가
              brndNm: this.item.brndNm ? this.item.brndNm : '', // GTM 작업을 위한 파라미터 추가
              variant: undefined // GTM 작업을 위한 파라미터 추가
            })
          }
          break
      }
    },

    // 장바구니 담기 데이터 셋팅
    async setSpbkData (param) {
      /* 장바구니 param
          spbkSeCd: '01', // [필수] 장바구니유형코드 [01: 택배배송, 02: 매장픽업, 03:정기배송, 04: 대량구매],
          chnlCd: 'B2C', // 채널코드 [01:B2C, 02:B2B] - 기업회원(40)인 경우 채널코드 B2B(02)
          orMdiaCd: this.getMdiaSeCd(), // [필수] 주문매체코드 [10:PC, 20:모바일웹, 30:모바일앱]
          pdNo: pdObj.pdNo, // 상품번호
          onldPdNo: pdObj.onldPdNo, // 온라인전용상품번호
          bunPdNo: pdObj.bunPdNo, // 세트상품번호
          spbkQy: pdObj.cnt, // 장바구니 수량
          inflPath: '', // 유입경로
          lsUpdrId: 'SCR_PDR_0001' // [필수] 화면ID(최종수정자아이디)
      */
      // 매장픽업이고 대량구매가 아닐 경우(매장픽업전용의 정의에 대량주문가능여부N추가됨)
      if (this.onlyPkup) {
        // 픽업 매장 변경 시 재고가 달라질 수 있습니다.
        await this.$alert(this.$t('PD.CART_PKUP'))
      }
      const urlParams = new URL(location.href).searchParams
      const inflPath = urlParams.get('infl_path') || ''
      const defaultObj = {
        chnlCd: 'B2C',
        orMdiaCd: this.getMdiaSeCd(),
        inflPath,
        lsUpdrId: 'SCR_PDR_0001'
      }
      if (param.constructor === Object) {
        const result = await this.addSpbk({ ...defaultObj, ...param })
        this.showSpbkMsg(result.row) // 결과값에 따른 메시지 노출
      } else if (param.constructor === Array) {
        const pdList = []
        param.forEach((item) => {
          pdList.push({ ...defaultObj, ...item })
        })
        const result = await this.addOptSpbk(pdList)
        this.showSpbkMsg(result.row)
      }
    },

    // 바로구매
    goBuy () {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }

      if (this.item.appDdcatPdYn === 'Y') {
        this.$alert(this.$t('PD.APP_PD_GUIDE_MSG'), {
          center: true,
          dangerouslyUseHTMLString: true
        })
        return
      }

      // 바로구매 노출 케이스 : 상품권, 옵션, 일반
      const params = {
        orPdCnt: this.totalCnt, // 주문상품수
        orPdAm: this.totalPrice, // 주문상품금액,
        orPdList: [] // 주문상품목록
      }
      const urlParams = new URL(location.href).searchParams
      const inflPath = urlParams.get('infl_path') || ''
      this.selPdList.forEach((pd) => {
        if (pd.cnt > 0) {
          params.orPdList.push({
            prdType: 'PRD_NORMAL', // 상품유형(고정값)
            pdNo: this.item.pdTy === '06' ? pd.onldPdNo : pd.pdNo, // 상품번호,
            onldPdNo: pd.onldPdNo, // 온라인상품번호,
            spbkQy: this.viewType !== 'bun' ? this.item.pdTy === '06' ? Math.floor(pd.cnt * this.item.jpQy) : pd.cnt : (this.pdCnt * pd.compQy), // 장바구니수량: 세트 상품일 경우 수량 * 세트당 구성품 수량,
            sleUtpc: this.item.pdTy === '06' ? Math.floor(pd.pdPrc / this.item.jpQy) : pd.pdPrc, // 판매단가, 상품가격과 동일
            dctUtpc: this.item.pdTy === '06' ? Math.floor(pd.pdPrc / this.item.jpQy) : pd.pdPrc, // 할인단가, 상품가격과 동일
            optCn: this.unescape(pd.optCn), // 옵션내용,
            exhPdNm: pd.exhPdNm, // 전시상품명,
            pdImgUrl: this.viewType !== 'bun' ? pd.imgUrl : pd.pdImgUrl, // 상품썸네일경로,
            dlvcPlcyCd: this.item.dlvcPlcyCd, // 배송비정책코드,
            brndCd: this.item.brndCd, // 브랜드코드,
            pdBrcd: this.item.pdBrcd, // 상품바코드,
            taxtSeCd: (this.item.pdTy === '05' || this.item.pdTy === '06') ? pd.taxtSeCd : this.item.taxtSeCd, // 과세구분코드
            inflPath, // 유입경로
            appDdcatPdYn: this.item.appDdcatPdYn,
            onlSclCd: this.item.onlSclCd, // 온라인소분류코드
            stck: this.viewType !== 'bun' ? pd.stckQy : Math.floor(pd.bunQy / pd.compQy), // 온라인재고: 세트 상품일 경우 (구성품 재고량 / 세트상품 묶음 기준 수량)
            pkgChkYn: this.isChkPkg || this.item.pdTy === '06' ? 'Y' : 'N', // 덕용체크여부
            pkgYn: this.item.pkgYn || this.item.pdTy === '06' ? 'Y' : 'N', // 덕용여부
            spbkSeCd: '01', // 장바구니구분코드 (01: 택배배송)
            brndNm: this.item.brndNm ? this.item.brndNm : '', // GTM용 브랜드네임
            purchaseValue: this.purchaseValue // GTM 작업을 위한 파라미터 추가
          })
        }
      })
      if (params.orPdList.length > 0) {
        this.$router.push({
          name: 'or-ora-SCR_ORA_0001',
          params
        })
      } else {
        // 옵션을 선택해주세요.
        this.alert(this.$t('PD.SELECT_OPTION'))
      }
    },

    // 상품권 구매/선물하기
    goGfCard (type) {
      if (!this.isLogin) {
        // 로그인 체크
        this.$router.push({ name: 'mb-mbb-SCR_MBB_0097A', params: { returnUrl: this.$route.fullPath } })
        return
      }
      const giftCardList = []
      this.selPdList.forEach((gf) => {
        if (gf.cnt > 0) {
          giftCardList.push({
            image: gf.imgUrl,
            price: gf.pdPrc,
            name: gf.exhPdNm,
            count: gf.cnt,
            pdNo: gf.pdNo,
            gfId: gf.gfId
          })
        }
      })
      if (!giftCardList.length) {
        // 옵션을 선택해주세요.
        this.$alert(this.$t('PD.SELECT_OPTION'))
        return
      }

      if (type === 'gift') {
        // 상품권 선물하기
        this.$router.push({
          name: 'or-ora-SCR_ORA_0010',
          path: '/or/ora/SCR_ORA_0010',
          params: { giftCardList }
        })
      } else if (type === 'buy') {
        // 상품권 바로구매
        this.$router.push({
          name: 'or-ora-SCR_ORA_0009',
          path: '/or/ora/SCR_ORA_0009',
          params: { giftCardList, selfPy: true }
        })
      }
    },

    // 장바구니 메시지 노출
    showSpbkMsg (result) {
      const getToastMessage = (status, purchaseValue) => {
        let prefix = ''
        switch (purchaseValue) {
          case '01':
            prefix = '택배배송'
            break
          case '02':
            prefix = '매장픽업'
            break
          case '03':
            prefix = '정기배송'
            break
          case '04':
            prefix = '대량주문'
            break
          case '05':
            prefix = '오늘배송'
            break
          default:
            prefix = ''
            break
        }
        return prefix ? `${prefix} ${status}` : status
      }

      let message = ''
      if (result > 0) {
        message = this.$t('PD.CART_SUCCESS')
      } else if (result === -1) {
        message = this.$t('OR.OVER_COUNT_CART')
      } else {
        // 여기서 message 대신 alert로 변경
        this.$alert(this.$t('OR.CART_FAIL'), { center: true, dangerouslyUseHTMLString: true })
        return // 더 이상 코드가 진행되지 않도록 return 추가
      }

      // 전송할 메시지 생성
      const toastMessage = getToastMessage(message, this.purchaseValue)
      this.openToast(toastMessage, { center: true, dangerouslyUseHTMLString: true })
    },

    // 덕용상품 옵션 없는 상품
    onPkgRdChange (props) { // 일반
      // 선택된 라디오 버튼 변경
      // 라디오 버튼 첫세팅시 old값은 첫값 (대량주문 팝업 이후 돌아갈 수 있도록 세팅 필요함)
      if (this.pkgOld === 0) {
        this.pkgOld = this.pkgList[0].optQy
      }

      if (this.pkgList[props].boxQy === 0) {
        this.isChkPkg = false
        this.$emit('sideBarPkgYn', false)
      } else {
        this.isChkPkg = true
        this.$emit('sideBarPkgYn', true)
      }

      this.pkgValue = props
      // 선택된 라디오 버튼만큼 수량 변경
      // 단품은 ins 없음
      this.$emit('pkgChange', this.pkgList[props].optQy)
      this.setData('cnt', this.item.onldPdNo, { curr: this.pkgList[props].optQy, old: this.pkgOld })
      this.pkgOld = this.pkgList[props].optQy
      this.setOldVal(this.pkgList[props].optQy)
    },
    // 덕용상품 옵션 상품 라디오 버튼 변경
    onOptPkgRdChange (data) {
      this.optPkgValue = data
      // 라디오버튼 수량 첫 선택시에만 옵션 박스 세팅 필요
      // 이미 세팅된 옵션 있는지 판단
      const isSet = this.selPdList.some(e => e.onldPdNo === this.selOpt)

      if (isSet === false) {
        // 라디오 버튼 첫세팅시 old값은 첫값 (대량주문 팝업 이후 돌아갈 수 있도록 세팅 필요함)
        this.pkgOld = ''
        this.setData('ins', this.selOpt, this.pkgList[data].optQy)
        this.pkgOld = this.pkgList[data].optQy
      } else {
        // 옵션 세팅되어 있는 경우 숫자만 변경
        this.setData('cnt', this.selOpt, { curr: this.pkgList[data].optQy, old: this.pkgOld })
        this.pkgOld = this.pkgList[data].optQy
      }
    },
    // 옵션 선택 슬라이드 버튼 좌우 이동 체크
    slideMove (props) {
      if (props.direction === 'prev') {
        if (this.activeOption !== 0) {
          this.activeOption -= 1
        }
      } else if (this.activeOption !== (this.item.pdOpt.length - 1)) {
        this.activeOption += 1
      }
    },
    // 덕용상품 스와이퍼 옵션 변경
    onChangePkgOpt (opt, idx) {
      // opt: 옵션 정보, idx: 인덱스
      this.selOpt = opt[idx].onldPdNo
    },
    // 라디오 버튼 value 세팅
    onPkgRdSet (idx) {
      if (this.isOpt) {
        // 옵션 있는 상품
        this.optPkgValue = idx
      } else {
        // 옵션 없는 상품
        this.pkgValue = idx
      }
    },
    setPkgDisabled (idx) {
      // 덕용 리스트 disabled false 초기화
      for (let i = 0; i < this.pkgList.length; i++) {
        this.$emit('disabledPkg', i, false)
      }
      if (this.isOpt) {
        // 옵션 상품 재고보다 덕용 셋팅 수가 큰 경우
        const isVal = this.pkgList.some(e => e.optQy > this.item.pdOpt[idx].stckQy)
        // 재고 없는 경우가 있다면 disabled 처리
        if (isVal) {
          for (let i = 0; i < this.pkgList.length; i++) {
            if (this.pkgList[i].optQy > this.item.pdOpt[idx].stckQy && this.pkgList[i].htrkCnvYn === 'N') {
              // pkgList 수량이 더 크고, 용차전환여부 N일 때 disabled 처리 (대량주문 가능하면 disabled 처리되면 안 됨)
              this.$emit('disabledPkg', i, true)
            } else {
              // pkgList 수량이 더 작을 경우 disabled 처리 안 함
              this.$emit('disabledPkg', i, false)
            }
          }
        }
      } else {
        // 옵션 아닌 경우
        const isVal = this.pkgList.some(e => e.optQy > this.item.stckQy)
        // 재고 없는 경우가 있다면 disabled 처리
        if (isVal) {
          for (let i = 0; i < this.pkgList.length; i++) {
            if (this.pkgList[i].optQy > this.item.stckQy && this.pkgList[i].htrkCnvYn === 'N') {
              // pkgList 수량이 더 클 경우 disabled 처리
              this.$emit('disabledPkg', i, true)
            } else {
              // pkgList 수량이 더 작을 경우 disabled 처리 안 함
              this.$emit('disabledPkg', i, false)
            }
          }
        }
      }
    },
    // 대량주문 팝업 발생, 라디오 변경시 old 값 이 컴포넌트에서 재세팅 필요
    setOldVal (data) {
      if (this.isOpt) {
        if (this.$refs.inputNum !== undefined) {
          this.$refs.inputNum[this.$refs.inputNum.findIndex(e => e.item.pdNo === this.selOpt)].oldVal = data
        }
      } else {
        this.$refs.inputNum.oldVal = data
      }
    },
    // 대량주문 팝업 발생시 old 값으로 라디오 버튼 변경 (data: 수량 옵션)
    setOldValRd (data) {
      if (data === 1 && this.isChkPkg) { // 이전 값이 낱개이고, 덕용 상품 최대 수량을 체크했을 경우
        this.isChkPkg = false // 이전으로 돌아왔을 때 수량 체크를 위한 isChkPkg 변경
      }
      if (this.isPkg || this.isChkPkg) {
        const isVal = this.pkgList.find(e => parseInt(e.optQy) === parseInt(data))
        if (isVal !== undefined) {
          this.onPkgRdSet(this.pkgList.findIndex(e => parseInt(e.optQy) === parseInt(data)))
        } else {
          // 해당되는 라디오값 없을 경우 라디오 선택 벗어남
          this.onPkgRdSet('')
          this.pkgOld = data
        }
      }
    },
    // 주문 수량 초과 alert 닫은 후 emit
    alertChange (val) {
      this.isAlert = val
    },
    setSelectNumberItem (onldPdNo) { // 상품 수량 선택을 위한 파라미터 세팅
      let nowQy = parseInt(this.item.stckQy) // 재고
      let maxOrQy = parseInt(this.item.maxOrPsblQy) > parseInt(this.item.stckQy) ? parseInt(this.item.stckQy) : parseInt(this.item.maxOrPsblQy)
      let massMinOrQy = parseInt(this.item.htrkCnvMummQy) * parseInt(this.item.jpQy)
      if (this.gfcardYn) {
        maxOrQy = 10
      } else if (!this.isOpt) {
        if (this.purchaseValue === '02') {
          maxOrQy = parseInt(this.item.maxOrPsblQy > this.pkupOfflStrStck ? this.pkupOfflStrStck : this.item.maxOrPsblQy)
        } else if (this.purchaseValue === '05') {
          maxOrQy = parseInt(this.item.quickMaxOrPsblQy > this.quickOfflStrStck ? this.quickOfflStrStck : this.item.quickMaxOrPsblQy)
          maxOrQy = maxOrQy === 0 ? 1 : maxOrQy
        } else if (this.isChkPkg || this.sideBarPkgYn || this.purchaseValue === '04' || this.item.pdTy === '06') { // 덕용 상품 OR 대량주문의 경우 수량, 최대구매가능수량 설정
          nowQy = Math.floor(nowQy / this.item.jpQy) // 수량 중포단위로 변경
          massMinOrQy = Math.floor(massMinOrQy / this.item.jpQy) // 대량배송최소수량 중포단위로 변경
          if (this.purchaseValue === '04') {
            if (this.item.massMaxOrPsblQyStdrCd === '02') {
              maxOrQy = this.item.massMaxOrPsblQy // 대량주문 관리자 설정 기준 최대구매가능수량 설정
            } else {
              maxOrQy = Math.floor(this.massOfflCntrStck / this.item.jpQy) // 대량주문 기준 최대구매가능수량 설정
            }
          } else if (this.purchaseValue === '01') {
            // 온라인 재고 수량과 중포 최대 가능 수량중에 작은 수량을 기준으로함
            maxOrQy = nowQy < parseInt(this.item.jpMaxOrPsblQy) ? nowQy : parseInt(this.item.jpMaxOrPsblQy) // 택배주문 기준 최대구매가능수량 설정
          }
        }
      } else {
        // eslint-disable-next-line no-lonely-if
        if (this.purchaseValue === '01' || this.purchaseValue === '03') { // 온라인 재고
          const idx = this.item.pdOpt.findIndex(e => e.onldPdNo === onldPdNo)
          nowQy = parseInt(this.item.pdOpt[idx].stckQy)
          maxOrQy = parseInt(this.item.pdOpt[idx].stckQy) > parseInt(this.item.pdOpt[idx].maxOrPsblQy) ? parseInt(this.item.pdOpt[idx].maxOrPsblQy) : parseInt(this.item.pdOpt[idx].stckQy)
        } else if (this.purchaseValue === '02') { // 픽업매장 재고
          if (this.item.pdTy === '05') {
            const selectedOpt = this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(onldPdNo))]
            nowQy = selectedOpt.pkupStck
            maxOrQy = selectedOpt.pkupStck > parseInt(selectedOpt.maxOrPsblQy) ? parseInt(selectedOpt.maxOrPsblQy) : selectedOpt.pkupStck
            if (nowQy > maxOrQy) {
              nowQy = maxOrQy
            }
          } else {
            nowQy = parseInt(this.pkupOfflStrStck)
            maxOrQy = parseInt(this.pkupOfflStrStck)
          }
        } else if (this.purchaseValue === '04') { // 대량주문 재고
          massMinOrQy = Math.floor(massMinOrQy / this.item.jpQy) // 대량배송최소수량 중포단위로 변경
          nowQy = parseInt(this.massOfflCntrStck)
          if (this.item.massMaxOrPsblQyStdrCd === '02') {
            maxOrQy = this.item.massMaxOrPsblQy // 대량주문 관리자 설정 기준 최대구매가능수량 설정
          } else {
            maxOrQy = Math.floor(nowQy / this.item.jpQy) // 수량 중포단위로 변경
          }
        } else if (this.purchaseValue === '05') {
          if (this.item.pdTy === '05') {
            console.log(this.item.onldOpt)
            console.log(onldPdNo)
            if (this.isLogin) {
              const quickOpt = this.item.onldOpt[this.item.onldOpt.findIndex(e => parseInt(e.onldPdNo) === parseInt(onldPdNo))]
              if (this.quickDlvUnable) {
                maxOrQy = parseInt(quickOpt.quickMaxOrPsblQy > this.quickOfflStrStck ? this.quickOfflStrStck : quickOpt.quickMaxOrPsblQy)
              } else {
                maxOrQy = parseInt(quickOpt.quickMaxOrPsblQy > quickOpt.quickStck ? quickOpt.quickStck : quickOpt.quickMaxOrPsblQy)
              }
            } else {
              maxOrQy = this.quickOfflStrStck
            }
          } else {
            maxOrQy = parseInt(this.item.quickMaxOrPsblQy > this.quickOfflStrStck ? this.quickOfflStrStck : this.item.quickMaxOrPsblQy)
            maxOrQy = maxOrQy === 0 ? 1 : maxOrQy
          }
        }
      }
      if (this.gfcardYn) {
        const selectNumberItem = {
          pdNo: onldPdNo,
          max: maxOrQy,
          stck: maxOrQy,
          massOrPsblYn: false,
          htrkCnvMummQy: 0,
          viewType: this.viewType,
          maxOrPsblQy: maxOrQy
        }
        return selectNumberItem
      } else if (onldPdNo) { // 옵션 상품의 경우
        const selectNumberItem = {
          pdNo: onldPdNo,
          max: this.item.massOrPsblYn === 'Y' && this.purchaseValue !== '04' ? massMinOrQy : this.item.maxOrPsblQy === 0 ? 999 : maxOrQy,
          stck: maxOrQy,
          massOrPsblYn: this.item.massOrPsblYn === 'Y',
          htrkCnvMummQy: massMinOrQy,
          viewType: this.viewType,
          maxOrPsblQy: maxOrQy,
          isOnldOpt: this.item.pdTy === '05',
          jpQy: this.item.jpQy
        }
        return selectNumberItem
      } else { // 그 외 일반 상품의 경우
        const selectNumberItem = {
          pdNo: this.item.onldPdNo,
          max: this.item.massOrPsblYn === 'Y' ? massMinOrQy : this.viewType === 'bun' ? this.item.bunMaxOrQy : this.item.maxOrPsblQy === 0 ? 999 : maxOrQy,
          stck: maxOrQy,
          massOrPsblYn: this.massOr,
          htrkCnvMummQy: massMinOrQy,
          viewType: this.viewType,
          maxOrPsblQy: maxOrQy
        }
        return selectNumberItem
      }
    },
    chkPkg () {
      this.isChkPkg = !this.isChkPkg
    }
  }
}
